export default __webpack_public_path__ + "static/media/PPI-pools-015.9fb05891.jpg";